import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { getCityGenericNameFromNumber } from "Utils/Common";
import { getTroopNameFromId } from "Utils/Common";
import { StringMap } from "./StringMap";
import { StringValue } from "./StringValue";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Reassign Troops">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Source/Destination Cities"}
          value={
            <>
              {getCityGenericNameFromNumber(
                task.taskstatusdetail.sourceCityNumber
              )}
              /
              {getCityGenericNameFromNumber(
                task.taskstatusdetail.destinationCityNumber
              )}
            </>
          }
        />
        <StringValue
          label={"Marches Done"}
          value={task.taskstatusdetail.marchesdone}
        />
        <StringMap
          label={"Troops Pending"}
          valueMap={task.taskstatusdetail.troopsqueued}
          valueParser={(k, v) => (
            <>
              {getTroopNameFromId(k)}: {v}
            </>
          )}
        />
        <StringMap
          label={"Troops Done"}
          valueMap={task.taskstatusdetail.troopsdone}
          valueParser={(k, v) => (
            <>
              {getTroopNameFromId(k)}: {v}
            </>
          )}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
